import { Tag, Sparkles, CalendarHeart } from "lucide-react";
import { PROMOS, waLink } from "@/config/site";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

const PLACEHOLDER_ICONS = [Tag, Sparkles, CalendarHeart];

export default function Promos() {
  return (
    <section id="promo" className="section-pad scroll-mt-20" data-testid="promos-section">
      <div className="container-x">
        <SectionHeading
          number="04"
          label="Promo & novità"
          title="Da non perdere da Farma Store"
          sub="Iniziative, novità e appuntamenti: scrivici per sapere cosa c'è in programma in questo periodo."
        />

        <div className="mt-12 grid gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3 lg:mt-16">
          {PROMOS.map((p, i) => {
            const Icon = PLACEHOLDER_ICONS[i % PLACEHOLDER_ICONS.length];
            return (
              <Reveal key={p.id} delay={i * 0.1}>
                <article data-testid={`promo-card-${p.id}`} className="card card-hover flex h-full flex-col overflow-hidden">
                  {p.image ? (
                    <a href={p.image} target="_blank" rel="noopener noreferrer" data-testid={`promo-image-${p.id}`} aria-label={`Apri l'immagine: ${p.title}`}>
                      <img src={p.image} alt={p.title} loading="lazy" className="w-full h-auto" />
                    </a>
                  ) : (
                    <div className="flex aspect-[16/10] w-full items-center justify-center bg-[#edf3ff]">
                      <Icon className="h-9 w-9 text-[#0050e0]/50" strokeWidth={1.5} />
                    </div>
                  )}
                  <div className="flex flex-1 flex-col p-7">
                    <span className="font-display text-[11px] font-bold uppercase tracking-[0.18em] text-[#0050e0]">
                      {p.tag}
                    </span>
                    <h3 className="font-display mt-3 text-xl font-bold tracking-tight text-[#1c1d1f]">{p.title}</h3>
                    <p className="mt-3 flex-1 text-sm leading-relaxed text-[#575a61]">{p.text}</p>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.2} className="mt-10 text-center sm:mt-12">
          <a
            href={waLink("Ciao, quali sono le promo del momento da Farma Store?")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="promos-whatsapp-button"
            className="btn-primary"
          >
            <WhatsAppIcon className="h-5 w-5" />
            Chiedici le promo del momento
          </a>
        </Reveal>
      </div>
    </section>
  );
}
